import { Component, OnInit, Input, Output, EventEmitter, AfterViewInit, ChangeDetectorRef, ElementRef } from '@angular/core';
import { GoogleService } from '../../../shared/Google.service'
import { Constants } from '../../../shared/models/constants';
@Component({
  selector: 'app-google-spreadsheet-enrichment',
  templateUrl: './google-spreadsheet-enrichment.component.html',
  styleUrls: ['./google-spreadsheet-enrichment.component.css']
})
export class GoogleSpreadsheetEnrichmentComponent implements OnInit {

  @Input() googleServicesObj: any;
  @Output() globalServicesCallBack: EventEmitter<any> = new EventEmitter<any>();

  public availableSpreadSheets;
  public enrichmentOptions = {};
  public currentHeader;
  public selectedThumbs = [];
  public noFilesFound: boolean = false;
  public noFilesFoundText: string;

  constructor(public googleService: GoogleService, private cdr: ChangeDetectorRef, private ele: ElementRef) { }

  ngOnInit() {

    //Initializing the loader
    this.ele.nativeElement.querySelector('.spreadSheetCon .lds-roller').style.display = 'block';

    var self = this;

    if (this.googleServicesObj.googleServiceType == "spreadSheet") {
      this.currentHeader = "Google Sheets";

      this.googleService.getSpreadSheetGoogleDrive().then(function (res) {
        if (res['length'] > 0) {
          self.availableSpreadSheets = res;
        }
        else {
          self.noFilesFound = true;
          self.noFilesFoundText = "No Spreadsheets available to show";
        }
        self.setThumbsnHideLoader();
      });

    }
    else if (this.googleServicesObj.googleServiceType == "googleDocs") {
      this.currentHeader = "Google Docs";

      this.googleService.getDocumentsGoogleDrive().then(function (res) {
        if (res['length'] > 0) {
          self.availableSpreadSheets = res;
        }
        else {
          self.noFilesFound = true;
          self.noFilesFoundText = "No Docs available to show";
        }
        self.setThumbsnHideLoader();
      });
    }
    else if (this.googleServicesObj.googleServiceType == "presentation") {
      this.currentHeader = "Google Slides";

      this.googleService.getPresentationsGoogleDrive().then(function (res) {
        if (res['length'] > 0) {
          self.availableSpreadSheets = res;
        }
        else {
          self.noFilesFound = true;
          self.noFilesFoundText = "No slides available to show";
        }
        self.setThumbsnHideLoader();
      });
    }

    this.enrichmentOptions = Constants.getEnrichmentOptions();
  }

  setThumbsnHideLoader() {

    if (this.availableSpreadSheets) {
      for (var i = 0; i <= this.availableSpreadSheets.length; i++) {
        if (this.availableSpreadSheets[i]) {
          this.availableSpreadSheets[i].isThumbActive = false;
        }
      }
    }
    //Hiding the loader
    this.ele.nativeElement.querySelector('.spreadSheetCon .lds-roller').style.display = 'none';
    this.cdr.detectChanges();
  }

  onFileClick(file) {
    file.isThumbActive = !file.isThumbActive;
    if (file.isThumbActive) {
      this.selectedThumbs.push(file);
    }
    else {
      var indOfThumb = this.selectedThumbs.findIndex(x => x.url == file.url);
      if (indOfThumb != -1) {
        this.selectedThumbs.splice(indOfThumb, 1);
      }
    }
  }

  hideSpeadSheetDialog(evt) {
    if (evt) {
      evt.stopPropagation();
    }
    else {
      this.googleServicesObj.showPopup = false;
    }
  }

  close() {
    this.hideSpeadSheetDialog(undefined);
  }

  addAsTab() {
    // let obj = this.enrichmentOptions[this.googleServicesObj.googleServiceType];
    // obj.url = this.selectedThumbs[0].alternateLink;
    let obj = {
      "type": this.googleServicesObj.googleServiceType,
      "selectedThumbs": this.selectedThumbs
    }
    if (this.selectedThumbs.length) {
      this.globalServicesCallBack.emit(obj);
      this.hideSpeadSheetDialog(undefined);
    }

  }

}



// WEBPACK FOOTER //
// ./src/app/bookShared/enrichmentTabs/google-spreadsheet-enrichment/google-spreadsheet-enrichment.component.ts